import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./context/ThemeContext";
import { CoinsProvider } from "./context/CoinsContext";
import HomePage from './pages/HomePage';
import DashboardPage from './pages/Dashboard';
import CoinPage from './pages/CoinPage';
import ComparePage from './pages/ComparePage';
import WatchListPage from './pages/WatchListPage';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <CoinsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/watchlist" element={<WatchListPage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/coin/:id" element={<CoinPage />} />
            </Routes>
          </BrowserRouter>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            limit={1}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
          />
        </CoinsProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
